// Central catalog of Conlang Book House titles.
// Adding new books: append a new object with a unique slug.

export const books = [
  {
    slug: "i-am-india",
    title: "I Am India",
    subtitle: "Discover Your Incredible Country",
    tagline: "The India Story.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/wwty67pp_I%20Am%20India.png",
    coverAlt: "I Am India — Discover Your Incredible Country cover",
    palette: { bg: "#F5EFE1", accent: "#B36A20", ink: "#0F1A33" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Icon Series",
    series: "The India Story",
    genres: ["India Story", "Cultural History", "Reference"],
    genreBlend: ["Cultural History", "Coffee-Table Reference"],
    format: "Deluxe Coffee-Table Hardcover",
    pages: 512,
    language: "English",
    isbn: "978-81-970004-0-1",
    price: 1999,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The flagship coffee-table volume of Conlang Book House — a single-object introduction to modern Bharat, built to sit on the table of every Indian home and every Indian embassy.",
    synopsis: `A country of 1.4 billion. Twenty-two official languages. Twenty-eight states. Eight union territories. Five thousand years of continuous civilisation. How do you hold all of that in one book?

I Am India is CBH's attempt. Built over three years with 40 photographers, 12 historians, and a rotating editorial board, this deluxe coffee-table volume moves state by state, era by era, and idea by idea — from the Indus Valley to Chandrayaan-3, from Kanyakumari to Ladakh, from the raga to the reactor. It is the book we wanted our children, our foreign friends, and our future selves to read first.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "in-production", Course: "available", Film: "in-production",
      Series: "in-production", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — One Country, Held in One Book",
      "Book I — The Land",
      "Book II — The Civilisation",
      "Book III — The Republic",
      "Book IV — The Twenty-Eight States",
      "Book V — The Idea of India, Now",
      "Coda — I Am India",
    ],
    reviews: [
      { author: "The Hindu Books", stars: 5, quote: "The most ambitious single-volume introduction to India ever attempted by an Indian publisher." },
      { author: "National Geographic — India", stars: 5, quote: "A landmark coffee-table volume." },
    ],
    isFlagship: true,
    isNewRelease: true,
  },
  {
    slug: "the-heat-survival-bible",
    title: "The Heat Survival Bible",
    subtitle: "Ancient Indian Wisdom for Europe's New Summers",
    tagline: "Europe wasn't built for 45°C. This book might save your summer — and perhaps your life.",
    cover: "https://customer-assets.emergentagent.com/job_d37acc54-5a6b-4b39-9da7-5e67d92778c3/artifacts/ne8vuzmb_The%20Heat%20Survival%20Bible.png",
    coverAlt: "The Heat Survival Bible cover",
    palette: { bg: "#F5E9E8", accent: "#8B1D1B", ink: "#3A0F0E" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang House List",
    series: "Bharat Wisdom Series",
    genres: ["Health", "Climate", "Cultural Studies"],
    genreBlend: ["Traditional Wisdom", "Climate Survival Guide"],
    format: "Trade Paperback",
    pages: 224,
    language: "English",
    isbn: "978-81-970000-2-9",
    price: 499,
    priceCurrency: "INR",
    releaseYear: 2025,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A field manual translating 5,000 years of Indian heat wisdom — from mud walls to buttermilk to shade geometry — into practical protocols for a warming Europe.",
    synopsis: `Europe's cities were engineered for cold. India's cities have known 45°C for centuries. This book bridges the two.

Combining Ayurvedic cooling protocols, vernacular architecture, dietary rhythms, and daily-life micro-adjustments, The Heat Survival Bible offers 47 tested techniques — each explained, illustrated, and adapted for a European household without a jaali window or an earthen matka.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Foreword — Why Europe Now Needs India",
      "Part One — The Body in Heat",
      "Part Two — The Home in Heat",
      "Part Three — The City in Heat",
      "Part Four — 47 Protocols",
      "Appendix — Seasonal Calendar",
    ],
    reviews: [
      { author: "The European Review of Books", stars: 5, quote: "The most quietly urgent book of the summer." },
      { author: "Down To Earth", stars: 5, quote: "A translation act — of wisdom, not just words." },
    ],
  },
  {
    slug: "the-man-who-defeated-the-british-empire",
    title: "The Man Who Defeated the British Empire",
    subtitle: "How a Walking Stick Shook the British Crown",
    tagline: "Mahatma Gandhi. Reinterpreted for a new century.",
    cover: "https://customer-assets.emergentagent.com/job_d37acc54-5a6b-4b39-9da7-5e67d92778c3/artifacts/h0131hu1_MG%20Gandhi.png",
    coverAlt: "The Man Who Defeated the British Empire — Mahatma Gandhi cover",
    palette: { bg: "#F4EEDD", accent: "#7B5A2A", ink: "#2A1F10" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Icon Series",
    series: "Bharat Icon Series",
    genres: ["History", "Biography", "Freedom Movement"],
    genreBlend: ["Historical Biography", "Political Philosophy"],
    format: "Hardcover",
    pages: 384,
    language: "English",
    isbn: "978-81-970000-4-3",
    price: 899,
    priceCurrency: "INR",
    releaseYear: 2025,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "Not the saint. Not the myth. The strategist — reconstructed through primary sources, colonial archives, and forgotten letters.",
    synopsis: `How does a man with a walking stick, a dhoti, and no army bring the largest empire in human history to its knees? This is not a book about Gandhi the saint. It is a book about Gandhi the strategist.

Drawing on colonial telegrams, cabinet minutes, and correspondence long ignored by Indian biographers, this volume reconstructs the mind behind non-violence as a political technology — patient, brutal in its clarity, and, in the end, unanswerable.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "available", Film: "not-licensed",
      Series: "not-licensed", Translation: "available", Merchandise: "available",
      Podcast: "in-production", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — A Walking Stick",
      "Book I — Porbandar to Pretoria",
      "Book II — Champaran to Chauri Chaura",
      "Book III — The Salt and the Sea",
      "Book IV — Quit India",
      "Book V — The Last Fast",
      "Coda — The Empire, After",
    ],
    reviews: [
      { author: "Frontline", stars: 5, quote: "Rescues Gandhi from both his worshippers and his detractors." },
      { author: "The Wire", stars: 4, quote: "Sharp, sourced, and unsentimental." },
    ],
  },
  {
    slug: "the-bjp-window-in-punjab",
    title: "The BJP Window in Punjab",
    subtitle: "How 2027 Could Reshape Punjab Politics",
    tagline: "Election Analysis on Punjab Assembly Elections 2027.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/lx255m6h_Bjp%20Window%20In%20Punjab.png",
    coverAlt: "The BJP Window in Punjab cover",
    palette: { bg: "#FFF3E4", accent: "#E76F1A", ink: "#2A1B10" },
    authors: ["kunal-prakash-jha"],
    imprint: "Conlang House List",
    series: "Election Analysis Series",
    genres: ["Political Analysis", "Punjab", "Elections"],
    genreBlend: ["Election Analysis", "Field Reportage"],
    format: "Trade Paperback",
    pages: 256,
    language: "English",
    isbn: "978-81-970000-5-0",
    price: 549,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first serious constituency-by-constituency analysis of what the 2027 Punjab Assembly Elections could look like — and why BJP now has a real window.",
    synopsis: `Punjab has been a party graveyard for the BJP for three decades. This book argues that pattern is about to break. Building on 117-seat modelling, booth-level demographic shifts, and post-farm-laws realignments, it makes the case for why 2027 opens a genuine window — and what BJP would need to do to walk through it.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "not-licensed", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "not-licensed",
    },
    tableOfContents: [
      "Introduction — The Punjab Puzzle",
      "Chapter 1 — 117 Seats, Twelve Regions",
      "Chapter 2 — The Hindu Vote Consolidation",
      "Chapter 3 — Panth, Party, Politics",
      "Chapter 4 — The Dera Question",
      "Chapter 5 — 2027 Scenarios",
    ],
    reviews: [
      { author: "The Tribune", stars: 5, quote: "The book Punjab-watchers didn't know they needed." },
    ],
  },
  {
    slug: "the-republic-of-children",
    title: "The Republic of Children",
    subtitle: "Cinema, Childhood & Cultural Nation-Building",
    tagline: "Creative Governance and the Power of Young Voices.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/br5m2k2q_Republic%20of%20Children%20%282%29.png",
    coverAlt: "The Republic of Children cover",
    palette: { bg: "#EBF1F5", accent: "#1F6478", ink: "#0F2B36" },
    authors: ["shravan-kumar-irs"],
    imprint: "Conlang Fellows",
    series: "Creative Governance",
    genres: ["Cultural Policy", "Cinema Studies", "Childhood"],
    genreBlend: ["Cultural Policy", "Personal Essay"],
    format: "Hardcover",
    pages: 312,
    language: "English",
    isbn: "978-81-970000-6-7",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A civil servant, a cinema hall, and a nation of children. A rare book on cultural policy that reads like a memoir.",
    synopsis: `What if a country's cultural imagination was measured not by its films or festivals, but by what it makes for and with its children? Drawing on two decades in the Indian Revenue Service and a lifelong love of cinema, Dr. Shravan Kumar constructs a bold new grammar for cultural nation-building — one where young voices sit at the centre, not the periphery.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "in-production", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Preface — The Boy at the Balcony",
      "Part I — What Children See",
      "Part II — What the State Shows",
      "Part III — A Blueprint",
      "Epilogue — A Republic, Rehearsed",
    ],
    reviews: [
      { author: "Economic & Political Weekly", stars: 5, quote: "Rare, humane, and quietly revolutionary." },
    ],
  },
  {
    slug: "the-indian-pillars-of-dubai",
    title: "The Indian Pillars of Dubai",
    subtitle: "Stories of Enterprise, Influence & Legacy",
    tagline: "The Faces Behind One of the World's Greatest Growth Stories.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/yu6l07t1_DUBAI%20BOOK%20COVER.png",
    coverAlt: "The Indian Pillars of Dubai cover",
    palette: { bg: "#EFF3F7", accent: "#0F2A5E", ink: "#08152E" },
    authors: ["kunal-prakash-jha"],
    imprint: "Conlang House List",
    series: "Diaspora & Enterprise",
    genres: ["Business", "Diaspora", "Enterprise"],
    genreBlend: ["Business Biography", "Diaspora Studies"],
    format: "Hardcover Deluxe",
    pages: 368,
    language: "English",
    isbn: "978-81-970000-7-4",
    price: 1299,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive record of how Indian enterprise built modern Dubai — and how modern Dubai, in turn, remade Indian ambition.",
    synopsis: `Behind the Burj Khalifa, DP World, and the skyline the world knows are 3.5 million Indians who quietly wrote one of the greatest urban growth stories in modern history. This book profiles the forty families and founders who built it — with interviews conducted across Dubai, Sharjah, Mumbai, Kochi, and Chennai over three years.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "not-licensed", Film: "in-production",
      Series: "in-production", Translation: "in-production", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "not-licensed",
    },
    tableOfContents: [
      "Prologue — Sand, Sea, Ship",
      "Book I — Founders (1960–1990)",
      "Book II — Builders (1990–2010)",
      "Book III — Inheritors (2010–Present)",
      "Book IV — The Next Fifty Years",
    ],
    reviews: [
      { author: "Khaleej Times", stars: 5, quote: "The book every UAE-based Indian will keep on a shelf." },
      { author: "Forbes India", stars: 5, quote: "Business history at its best." },
    ],
  },
  {
    slug: "the-half-of-the-nation-speaks",
    title: "The Half of the Nation Speaks",
    subtitle: "Women, Power, and the Battle for India's Parliament",
    tagline: "The Fight for Representation. The Future of India.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/9a27q7jt_The%20Half%20of%20the%20Nation%20Speaks.webp",
    coverAlt: "The Half of the Nation Speaks cover",
    palette: { bg: "#EBF2EA", accent: "#1F5A3A", ink: "#0F2A1D" },
    authors: ["rashmi-sharma"],
    imprint: "Conlang House List",
    series: "Contemporary Democracy",
    genres: ["Gender", "Politics", "Democracy"],
    genreBlend: ["Political Essay", "Reportage"],
    format: "Hardcover",
    pages: 304,
    language: "English",
    isbn: "978-81-970000-8-1",
    price: 749,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The Women's Reservation Bill has passed. The harder question begins now. A book about what representation actually means.",
    synopsis: `India has legislated 33% women's representation in Parliament. The Half of the Nation Speaks is the first full-length reckoning with what that legislation will — and won't — do. Combining constitutional history, delimitation modelling, and profiles of the women already reshaping Indian politics, this book asks what it takes to move from seats to power.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prologue — 128 Years, One Bill",
      "Part I — The Fight for the Bill",
      "Part II — The Women Already There",
      "Part III — The Women Still Waiting",
      "Part IV — 2029 and After",
    ],
    reviews: [
      { author: "Scroll.in", stars: 5, quote: "The definitive book on this moment." },
    ],
  },
  {
    slug: "start-before-youre-ready",
    title: "Start Before You're Ready",
    subtitle: "Overcoming Perfectionism & Procrastination",
    tagline: "The Myth of the Perfect Moment.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/e3rradq8_Start%20Before%20You%27re%20Ready.png",
    coverAlt: "Start Before You're Ready cover",
    palette: { bg: "#FFF1EC", accent: "#F17A6B", ink: "#1B2B4B" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Wellbeing",
    series: "Everyday Self-Help",
    genres: ["Self-Help", "Productivity", "Personal Growth"],
    genreBlend: ["Self-Help", "Behavioural Science"],
    format: "Trade Paperback",
    pages: 216,
    language: "English",
    isbn: "978-81-970001-0-4",
    price: 349,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A short, sharp field guide for the perfectionist who cannot begin — and the procrastinator who cannot stop researching how to.",
    synopsis: `The perfect moment does not exist. The perfect plan does not exist. The perfectly prepared version of you does not exist. What exists is the imperfect first step — and, sooner or later, the compounding return on having taken it.

Written by CBH's Wellbeing desk in collaboration with cognitive-behavioural specialists, this book is a working manual for anyone stuck on the runway. Twenty-one chapters, twenty-one starts. Each chapter ends with a two-minute action you can take before you turn the page.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Runway You Never Leave",
      "Part I — The Myth of the Perfect Moment",
      "Part II — The Physics of a First Step",
      "Part III — Twenty-One Starts",
      "Part IV — The Compounding Life",
      "Coda — The Book You Finish",
    ],
    reviews: [
      { author: "The Bookshelf Quarterly", stars: 5, quote: "Kind, sharp, and unusually honest about why we do not begin." },
      { author: "Mind & Body Weekly", stars: 5, quote: "A self-help book that respects the reader's intelligence." },
    ],
  },
  {
    slug: "the-comparison-trap",
    title: "The Comparison Trap",
    subtitle: "Escaping Social Comparison in the Social-Media Age",
    tagline: "Focus on your own journey.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/kwaee0pe_The%20Comparison%20Trap.png",
    coverAlt: "The Comparison Trap cover",
    palette: { bg: "#FDEEF2", accent: "#E36FA8", ink: "#1F2340" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Wellbeing",
    series: "Everyday Self-Help",
    genres: ["Self-Help", "Mental Health", "Digital Life"],
    genreBlend: ["Self-Help", "Digital Wellbeing"],
    format: "Trade Paperback",
    pages: 192,
    language: "English",
    isbn: "978-81-970001-1-1",
    price: 329,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A gentle, deeply-researched exit route from the algorithmic mirror — for anyone who has scrolled themselves into someone else's life.",
    synopsis: `Every time you unlock your phone, you enter a coliseum of curated lives. The average adult now performs three hundred social comparisons a day — most of them without noticing. This book asks a simple question: what would it feel like to opt out?

Combining psychological research, contemplative traditions, and long-form interviews with twenty-somethings across three continents, The Comparison Trap draws a map back to your own life. Not the one on the timeline. The one you are actually living.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Three Hundred Times a Day",
      "Part I — The Mirror in Your Pocket",
      "Part II — Who Are You Comparing To?",
      "Part III — Reclaiming the Timeline",
      "Part IV — The Journey That Is Yours",
      "Coda — A Quieter Feed",
    ],
    reviews: [
      { author: "Wellbeing India", stars: 5, quote: "The digital-detox book that finally does not condescend." },
      { author: "The Youth Review", stars: 5, quote: "Every college student should read this before their next scroll." },
    ],
  },
  {
    slug: "the-calm-leader",
    title: "The Calm Leader",
    subtitle: "The EQ Story — Peace is Power",
    tagline: "Emotional intelligence as the ultimate leadership advantage.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/9l0yakec_The%20Calm%20Leader.png",
    coverAlt: "The Calm Leader — The EQ Story cover",
    palette: { bg: "#EEF3EB", accent: "#2E5B36", ink: "#132318" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Wellbeing",
    series: "Leadership & EQ",
    genres: ["Self-Help", "Leadership", "Emotional Intelligence"],
    genreBlend: ["Self-Help", "Business Wisdom"],
    format: "Hardcover",
    pages: 260,
    language: "English",
    isbn: "978-81-970001-2-8",
    price: 599,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive Indian volume on emotional intelligence for leaders — drawn from Buddhist calm, Stoic restraint, and boardroom evidence.",
    synopsis: `Every great leader you can name has one thing in common: an interior temperature that does not spike. Not because they feel nothing — but because they have trained themselves not to be led by what they feel.

The Calm Leader is a book about that training. It draws on 2,500 years of Indian and Eastern contemplative practice, cross-checks it against contemporary behavioural science, and translates it into the everyday grammar of the modern workplace. Peace, this book argues, is not the absence of ambition. Peace is power.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "not-licensed", Translation: "available", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Interior Temperature",
      "Part I — The Untrained Mind at Work",
      "Part II — Five EQ Practices",
      "Part III — The Calm Team",
      "Part IV — Peace as Power",
      "Coda — The Leader Who Does Not Flinch",
    ],
    reviews: [
      { author: "Harvard Business Review India", stars: 5, quote: "The Indian answer to a decade of Western EQ literature." },
      { author: "The Mint Leadership Series", stars: 5, quote: "Rigorous, rooted, and reassuring." },
    ],
  },
  {
    slug: "the-discipline-of-small-mornings",
    title: "The Discipline of Small Mornings",
    subtitle: "Building Daily Habits That Compound",
    tagline: "Success isn't loud. It wakes up early.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/e7i5tocq_The%20Discipline%20of%20Small%20Mornings.png",
    coverAlt: "The Discipline of Small Mornings cover",
    palette: { bg: "#F5EFE3", accent: "#B58A2E", ink: "#1A1613" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Wellbeing",
    series: "Everyday Self-Help",
    genres: ["Self-Help", "Habits", "Productivity"],
    genreBlend: ["Self-Help", "Behavioural Design"],
    format: "Trade Paperback",
    pages: 232,
    language: "English",
    isbn: "978-81-970001-3-5",
    price: 379,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A quiet manual on how the smallest daily practices compound into an unrecognisably larger life.",
    synopsis: `The visible result is the loud part. The invisible practice is the discipline. This book is about the second half — the four unglamorous minutes that make the four visible years possible.

Structured around six repeatable morning practices and thirty-one supporting micro-habits, The Discipline of Small Mornings translates the compounding logic that governs money, muscle, and mastery into a daily routine that survives contact with a real life. No 4 a.m. martyrdom. No cold-plunge theatre. Just a small, honest morning — done, again, tomorrow.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Loud Result, The Quiet Practice",
      "Part I — Why Mornings Compound",
      "Part II — The Six Practices",
      "Part III — Thirty-One Micro-Habits",
      "Part IV — The Year, Un-Recognised",
      "Coda — Tomorrow, Again",
    ],
    reviews: [
      { author: "The Everyday Reader", stars: 5, quote: "A habits book you can actually keep." },
      { author: "Wellbeing India", stars: 5, quote: "Grounded, humane, and quietly transformative." },
    ],
  },
  {
    slug: "the-forests-daughter",
    title: "The Forest's Daughter",
    subtitle: "The C. K. Janu Story",
    tagline: "A lifetime dedicated to indigenous rights.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/haoce6xp_The%20Forest%27s%20Daughter.png",
    coverAlt: "The Forest's Daughter — The C. K. Janu Story cover",
    palette: { bg: "#F5EEF3", accent: "#7B2F52", ink: "#2A0F1E" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Women Icons",
    series: "Bharat Women Icons Series",
    genres: ["Women Leadership", "Biography", "Indigenous Rights"],
    genreBlend: ["Political Biography", "Field Reportage"],
    format: "Hardcover",
    pages: 296,
    language: "English",
    isbn: "978-81-970002-0-3",
    price: 749,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first full-length English biography of C. K. Janu — the Adivasi leader who turned a forest into a movement.",
    synopsis: `C. K. Janu began her working life at seven, on someone else's land. She ended the twentieth century leading Kerala's largest Adivasi land-rights movement. The story between those two points is one of the most consequential — and least written — chapters in modern Indian political history.

Drawing on years of field reporting from Wayanad, oral histories from Muthanga, and previously unpublished government correspondence, The Forest's Daughter reconstructs Janu's life as both biography and testimony. It is a book about a forest, a woman, and the country that has still not fully heard either.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "available", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Seven Years Old, and Working",
      "Book I — Wayanad",
      "Book II — The Movement",
      "Book III — Muthanga",
      "Book IV — After the Headlines",
      "Coda — The Forest, Still Standing",
    ],
    reviews: [
      { author: "Frontline", stars: 5, quote: "The Janu biography that Indian publishing has owed the country for two decades." },
      { author: "The Caravan", stars: 5, quote: "Reported with the seriousness the subject demands." },
    ],
  },
  {
    slug: "the-lady-with-the-white-coat",
    title: "The Lady with the White Coat",
    subtitle: "Dr. Indira Hinduja: The IVF Story",
    tagline: "She gave hope where none existed.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/esiyr16l_The%20Lady%20With%20the%20White%20Coat.png",
    coverAlt: "The Lady with the White Coat — Dr. Indira Hinduja cover",
    palette: { bg: "#EEF4F3", accent: "#1F6272", ink: "#0F2A32" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Women Icons",
    series: "Bharat Women Icons Series",
    genres: ["Women Leadership", "Biography", "Science"],
    genreBlend: ["Scientific Biography", "Medical History"],
    format: "Hardcover",
    pages: 312,
    language: "English",
    isbn: "978-81-970002-1-0",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive account of the woman who delivered India's first IVF and GIFT babies — and rewrote what modern Indian medicine could believe about itself.",
    synopsis: `In August 1986, Dr. Indira Hinduja delivered the first scientifically-documented IVF baby born on Indian soil. Four years later, she did it again with India's first GIFT baby. Between those two births lie four decades of laboratory hours, quiet institutional battles, and a stubborn refusal to let Indian medicine believe it had to import its miracles.

The Lady with the White Coat tells that story in full. Reconstructed through KEM Hospital archives, family papers, patient testimony, and hundreds of hours of interviews with the doctor herself, this is the book Indian medicine has waited for.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — August 6, 1986",
      "Book I — Karachi to Bombay",
      "Book II — KEM",
      "Book III — Two Babies",
      "Book IV — A Practice, A Movement",
      "Coda — What Hope Looks Like",
    ],
    reviews: [
      { author: "The Lancet — India Correspondence", stars: 5, quote: "A landmark biography of a landmark scientist." },
      { author: "The Hindu Books", stars: 5, quote: "Long overdue, beautifully done." },
    ],
  },
  {
    slug: "the-mountain-said-yes",
    title: "The Mountain Said Yes",
    subtitle: "Arunima Sinha & Her Impossible Story",
    tagline: "She lost a leg, but conquered Everest.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/3a2u1e2s_The%20Mountain%20Said%20Yes.png",
    coverAlt: "The Mountain Said Yes — Arunima Sinha cover",
    palette: { bg: "#EAF0F5", accent: "#E76F1A", ink: "#12274A" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Women Icons",
    series: "Bharat Women Icons Series",
    genres: ["Women Leadership", "Biography", "Sport & Adventure"],
    genreBlend: ["Sports Biography", "Human Interest"],
    format: "Hardcover",
    pages: 244,
    language: "English",
    isbn: "978-81-970002-2-7",
    price: 649,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A pushed-off-a-train volleyball player. A prosthetic leg. Two years of training. One Everest summit. The impossible story, told properly.",
    synopsis: `In April 2011, Arunima Sinha was thrown off a moving train and lost her left leg below the knee. Twenty-five months later, she stood at 8,848 metres — the first female amputee in human history to summit Mount Everest. She has since summited Kilimanjaro, Elbrus, Aconcagua, Denali, Vinson, and Kosciuszko.

The Mountain Said Yes reconstructs the interior grammar of that achievement. Not the highlight reel — the training logs, the prosthetic re-fittings, the sponsorship rejections, the family arguments, the surgeries no one talks about. It is a book about what the impossible actually costs. And what it gives back.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "in-production", Film: "in-production",
      Series: "not-licensed", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — 8,848 Metres",
      "Book I — Ambedkar Nagar to Bareilly",
      "Book II — The Padmavati Express",
      "Book III — TISS, Uttarkashi, and a Prosthetic",
      "Book IV — Everest",
      "Book V — The Seven Summits",
      "Coda — What the Mountain Gave Back",
    ],
    reviews: [
      { author: "Sportstar India", stars: 5, quote: "The Arunima book we've been asking for since 2013." },
      { author: "Outlook Magazine", stars: 5, quote: "Heart-in-throat, but sourced like a court case." },
    ],
  },
  {
    slug: "the-missile-woman-of-india",
    title: "The Missile Woman of India",
    subtitle: "Tessy Thomas: The Agni Story",
    tagline: "She aimed beyond the sky — and changed India's defence forever.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/qysa1wpr_The%20Missile%20Woman%20of%20India.png",
    coverAlt: "The Missile Woman of India — Tessy Thomas cover",
    palette: { bg: "#FBEFF3", accent: "#C7276A", ink: "#28112A" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Women Icons",
    series: "Bharat Women Icons Series",
    genres: ["Women Leadership", "Biography", "Science"],
    genreBlend: ["Scientific Biography", "Defence History"],
    format: "Hardcover",
    pages: 336,
    language: "English",
    isbn: "978-81-970002-3-4",
    price: 899,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The complete life of Tessy Thomas — India's first woman scientist to head a missile project, and the woman Dr. Kalam himself called 'Agniputri'.",
    synopsis: `Long before India's newspapers noticed, Tessy Thomas was already running the Agni-IV programme. She was the first Indian woman to head a strategic missile project, the first to be Project Director of an Agni missile launch, and — to Dr. A.P.J. Abdul Kalam — his 'Agniputri'.

The Missile Woman of India is the first full-length biography of a scientist whose career shaped Indian strategic doctrine. Built on DRDO archives, cabinet-cleared interviews, and the family papers of the Thomas family, it is at once a life, a laboratory, and a country's rising range.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "available", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Agniputri",
      "Book I — Alappuzha to Pune",
      "Book II — DRDO",
      "Book III — Agni-II, III, IV, V",
      "Book IV — The Woman at the Console",
      "Book V — Legacy",
      "Coda — Beyond the Sky",
    ],
    reviews: [
      { author: "India Strategic", stars: 5, quote: "The strategic biography Indian defence writing has needed." },
      { author: "The Print — Defence", stars: 5, quote: "Rigorous, respectful, and long overdue." },
    ],
  },
  {
    slug: "the-vote-bank-diplomacy",
    title: "The Vote Bank Diplomacy",
    subtitle: "The Indian Diaspora's Political Influence",
    tagline: "How elections abroad shape policy at home.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/2j8yxp4a_The%20Vote%20Bank%20Diplomacy.png",
    coverAlt: "The Vote Bank Diplomacy cover",
    palette: { bg: "#EDF3FA", accent: "#1F6FB2", ink: "#0F2A4A" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Geopolitics",
    series: "Geopolitics Series",
    genres: ["Geo-Politics", "Diaspora", "Foreign Policy"],
    genreBlend: ["Geopolitics", "Diaspora Studies"],
    format: "Hardcover",
    pages: 344,
    language: "English",
    isbn: "978-81-970003-0-2",
    price: 899,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first serious book on how 32 million Indians abroad quietly redraw Indian foreign policy — one election, one PAC, one op-ed at a time.",
    synopsis: `Somewhere between the New Jersey suburbs, the West London high streets, and the Silicon Valley boardrooms sits a voter that Indian foreign policy has learned to read very carefully. The Indian diaspora — 32 million strong, spread across 200+ countries, and increasingly organised — is no longer just a remittance story. It is a diplomacy story.

The Vote Bank Diplomacy is the first full-length reckoning with what that story actually looks like. Built on four years of reporting across five continents, PAC filings, embassy correspondence, and interviews with 140+ diaspora political operatives, this book argues that Indian foreign policy is now written, in part, by voters who do not live in India.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Voter Who Does Not Live Here",
      "Book I — The Making of a Diaspora Vote",
      "Book II — Washington, Westminster, Canberra",
      "Book III — PACs, Op-Eds, and Ambassadors",
      "Book IV — Delhi Reads the Diaspora",
      "Book V — 2029 and After",
      "Coda — The New Foreign Office",
    ],
    reviews: [
      { author: "The Diplomat Magazine", stars: 5, quote: "The book Indian foreign policy has needed for a decade." },
      { author: "Foreign Affairs — India Watch", stars: 5, quote: "Rigorous, contemporary, and quietly revelatory." },
    ],
  },
  {
    slug: "the-border-that-never-sleeps",
    title: "The Border That Never Sleeps",
    subtitle: "Life along LoC & LAC",
    tagline: "Life along the world's most-guarded line.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/jjb1r50b_The%20Border%20that%20Never%20Sleeps.png",
    coverAlt: "The Border That Never Sleeps cover",
    palette: { bg: "#EEF1F5", accent: "#1F3A63", ink: "#0F1F35" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Geopolitics",
    series: "Geopolitics Series",
    genres: ["Geo-Politics", "Defence", "Reportage"],
    genreBlend: ["Geopolitics", "Frontline Reportage"],
    format: "Hardcover",
    pages: 368,
    language: "English",
    isbn: "978-81-970003-1-9",
    price: 949,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "Two decades of field reporting from the Line of Control and the Line of Actual Control — the world's most closely-watched lines, and the villages that live on them.",
    synopsis: `The Line of Control is 740 kilometres long. The Line of Actual Control is over 3,400. Together, they form the most closely-guarded frontier on Earth. But the story of the border is not the story of the soldiers alone. It is also the story of the villages, the postmasters, the schoolteachers, and the children on both sides who go to sleep every night to the sound of the world's largest militaries moving in the dark.

Reconstructed from two decades of field reporting — from Uri to Tawang, from Kargil to Demchok — The Border That Never Sleeps is the definitive human portrait of what it means to live on India's two most consequential lines.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "in-production",
      Series: "in-production", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Sound of the Line at Night",
      "Book I — LoC: Uri to Kargil",
      "Book II — LoC: The Kashmir Villages",
      "Book III — LAC: Ladakh",
      "Book IV — LAC: Arunachal & Sikkim",
      "Book V — The Diplomacy on the Line",
      "Coda — Sleep, If You Can",
    ],
    reviews: [
      { author: "The Indian Express — Defence", stars: 5, quote: "The border book Indian journalism has been trying to write for twenty years." },
      { author: "India Strategic", stars: 5, quote: "Field-first, doctrine-aware, human throughout." },
    ],
  },
  {
    slug: "sanctions-and-samosas",
    title: "Sanctions & Samosas",
    subtitle: "The Economic Diplomacy Story",
    tagline: "How trade quietly rewrote foreign policy.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/rcigzsmt_Sanctions%20%26%20Samosas%20Book%20Cover.png",
    coverAlt: "Sanctions & Samosas — The Economic Diplomacy Story cover",
    palette: { bg: "#0E1420", accent: "#D4AF37", ink: "#F5EED8" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Geopolitics",
    series: "Geopolitics Series",
    genres: ["Geo-Politics", "Economics", "Trade"],
    genreBlend: ["Geopolitics", "Economic History"],
    format: "Hardcover Deluxe",
    pages: 400,
    language: "English",
    isbn: "978-81-970003-2-6",
    price: 1199,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A deluxe volume on how, quietly and unglamorously, trade policy has become foreign policy — and India has learned to write both at once.",
    synopsis: `The old handshake diplomacy has been quietly displaced by something less telegenic and considerably more consequential: a global chessboard of tariffs, sanctions, export controls, FTAs, and trade-corridor treaties. Foreign policy today is written in balance-sheet ink.

Sanctions & Samosas is a deluxe volume on that shift — reconstructed through Indian embassy trade cables, CEPA negotiation minutes, WTO filings, and interviews with over eighty senior trade officials, negotiators, and commodity chiefs. It argues, with data and narrative in equal measure, that the twenty-first century will be won by the country that treats every trade round as a foreign-policy summit.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Table Where Deals Are Made",
      "Book I — The Age of Sanctions",
      "Book II — CEPA, FTA, RCEP",
      "Book III — Chips, Energy, Rare Earths",
      "Book IV — Corridors: IMEC, INSTC, and Beyond",
      "Book V — India's Trade Foreign Policy",
      "Coda — The Deluxe Print of a Small Table",
    ],
    reviews: [
      { author: "Financial Times — India", stars: 5, quote: "A landmark on Indian economic diplomacy — the first volume of its kind." },
      { author: "The Economist — Bagehot India", stars: 5, quote: "Reads like a trade cable, written like a novel." },
    ],
  },
  {
    slug: "the-himalayan-chessboard",
    title: "The Himalayan Chessboard",
    subtitle: "The India–China Story",
    tagline: "Where empires watch and borders whisper.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/8xwx485e_The%20Himalayan%20Chessboard%20Book%20Cover.png",
    coverAlt: "The Himalayan Chessboard — The India–China Story cover",
    palette: { bg: "#0E1622", accent: "#C9A24A", ink: "#F1E9CE" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Geopolitics",
    series: "Geopolitics Series",
    genres: ["Geo-Politics", "China Watch", "Foreign Policy"],
    genreBlend: ["Geopolitics", "Strategic History"],
    format: "Hardcover Deluxe",
    pages: 448,
    language: "English",
    isbn: "978-81-970003-3-3",
    price: 1299,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive single-volume account of the India–China relationship — from Panchsheel to Galwan to the next quiet quarter-century.",
    synopsis: `Two civilisations. Three thousand kilometres of shared frontier. Seven decades of a relationship that has swung between poetry, war, trade, silence, and standoff. The Himalayan Chessboard is the first single-volume attempt to hold all of it in one narrative.

Built on declassified MEA papers, PLA-adjacent scholarship, Chinese-language sources, and interviews with three former Indian ambassadors to Beijing, this deluxe hardcover reconstructs the relationship from Panchsheel and Bandung through the 1962 war, the Rajiv Gandhi thaw, Doklam, Galwan, and the quiet, chess-like manoeuvres of the last twenty-four months.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "in-production", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Two Civilisations, One Line",
      "Book I — Panchsheel to 1962",
      "Book II — The Long Silence",
      "Book III — Rajiv, Vajpayee, Manmohan",
      "Book IV — Doklam & Galwan",
      "Book V — The Quiet Quarter-Century",
      "Coda — Where Empires Watch",
    ],
    reviews: [
      { author: "The Hindu Books", stars: 5, quote: "The India–China book Indian publishing has been circling for a decade." },
      { author: "Foreign Policy — Asia Desk", stars: 5, quote: "Reads like a strategic paper. Writes like a novel." },
    ],
  },
  {
    slug: "ai-for-young-minds",
    title: "AI for Young Minds",
    subtitle: "Meet Your New Digital Friend",
    tagline: "A first, kind, curious introduction to Artificial Intelligence.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/m995t0ll_AI%20for%20Young%20Minds.png",
    coverAlt: "AI for Young Minds — Meet Your New Digital Friend cover",
    palette: { bg: "#EDF0FA", accent: "#4A5AE0", ink: "#0F1740" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Little Readers",
    series: "Little Readers — Big Ideas",
    genres: ["Children", "STEM", "Technology"],
    genreBlend: ["Children's Non-Fiction", "STEM"],
    format: "Illustrated Paperback",
    pages: 96,
    language: "English",
    isbn: "978-81-970005-0-0",
    price: 349,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    ageRange: "8–12 years",
    editorialNote: "A warm, illustrated first-book about AI for children — no jargon, no fear, only wonder. What AI is, what it isn't, and how to grow up thinking beside it.",
    synopsis: `AI is going to be the classmate every child grows up with. This book is the first, kindest, and most curious introduction we could design.

Written for children aged 8–12, AI for Young Minds explains what artificial intelligence actually is (and what it is not), how it learns, what it can do brilliantly, where it gets things wrong, and — most importantly — how a child can grow up alongside it as a thoughtful, curious, and kind human. No jargon. No fear. Only wonder.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Hello, Digital Friend",
      "What Is Artificial Intelligence?",
      "How Does a Machine Learn?",
      "The Things AI Does Brilliantly",
      "The Things AI Gets Wrong",
      "You and Your Digital Friend",
      "A Little Glossary",
    ],
    reviews: [
      { author: "Parent Circle India", stars: 5, quote: "The AI book Indian parents have been waiting for." },
      { author: "The Hindu — Young World", stars: 5, quote: "Warm, wondrous, and just the right amount of technical." },
    ],
  },
  {
    slug: "the-sarpanchs-smallest-helper",
    title: "The Sarpanch's Smallest Helper",
    subtitle: "A Village Tale",
    tagline: "You don't have to be big to make a big difference.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/ofrxxwgr_The%20Sarpanch%27s%20Smallest%20Helper.png",
    coverAlt: "The Sarpanch's Smallest Helper — A Village Tale cover",
    palette: { bg: "#F2F0DE", accent: "#5C7A2F", ink: "#22320E" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Little Readers",
    series: "Little Readers — Village Tales",
    genres: ["Children", "Picture Book", "Civic Values"],
    genreBlend: ["Children's Fiction", "Civic Storytelling"],
    format: "Illustrated Paperback",
    pages: 64,
    language: "English",
    isbn: "978-81-970005-1-7",
    price: 299,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    ageRange: "6–10 years",
    editorialNote: "A gently illustrated village tale about a small boy who quietly makes his gram panchayat a better place — and, without knowing it, teaches everyone else how.",
    synopsis: `Every village has a Sarpanch. Not every village notices the smallest helper standing beside him.

In a small village not too far from anywhere, a young boy named Arav starts turning up at the gram panchayat every evening — bringing water, arranging chairs, carrying files. He does not know he is doing anything important. The village does. Slowly, quietly, and without a single loud word, he changes everything.

A gentle, illustrated tale for readers aged 6–10 about civic imagination, quiet leadership, and the difference a small helper can make.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "available", Course: "not-licensed", Film: "in-production",
      Series: "in-production", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "The Village",
      "Arav Arrives",
      "The Chair, The Water, The File",
      "The Sarpanch Notices",
      "The Village Notices",
      "The Smallest Helper",
    ],
    reviews: [
      { author: "The Book Review India — Young Readers", stars: 5, quote: "A quiet, beautiful book about civic love." },
      { author: "First Post — Kids", stars: 5, quote: "The kind of story every classroom should own." },
    ],
  },
  {
    slug: "i-am-india-the-india-story",
    title: "I Am India",
    subtitle: "The India Story — Discover Your Incredible Country",
    tagline: "The children's edition of the CBH flagship.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/qk6q1oq4_I%20Am%20India.png",
    coverAlt: "I Am India — The India Story — Children's Edition cover",
    palette: { bg: "#F5EFE1", accent: "#B36A20", ink: "#0F1A33" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Little Readers",
    series: "The India Story",
    genres: ["Children", "India Story", "Reference"],
    genreBlend: ["Children's Reference", "Cultural History"],
    format: "Illustrated Paperback",
    pages: 128,
    language: "English",
    isbn: "978-81-970005-2-4",
    price: 449,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    ageRange: "8–14 years",
    editorialNote: "The younger-reader companion to the CBH flagship. A single-object children's introduction to modern Bharat — 28 states, 5,000 years, one country, held in one book.",
    synopsis: `The deluxe coffee-table I Am India sits on the family table. This paperback edition — designed for readers aged 8–14 — is the one they carry to school, mark up, and grow up with.

Every state, every era, every idea — retold at a pace and warmth built for younger readers, without ever talking down to them. A book that grows with the child, from Grade 4 through Grade 10.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "One Country, Held in One Book",
      "The Land",
      "The Civilisation",
      "The Republic",
      "The Twenty-Eight States",
      "The Idea of India",
      "I Am India",
    ],
    reviews: [
      { author: "The Hindu — Young World", stars: 5, quote: "The India book every Indian child should grow up with." },
      { author: "Parent Circle", stars: 5, quote: "A gift that outlasts every screen." },
    ],
  },
  {
    slug: "the-mango-tree-parliament",
    title: "The Mango Tree Parliament",
    subtitle: "A Story About Democracy",
    tagline: "Where the village kids learn to disagree kindly.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/0nxir9hp_The%20Mango%20Tree%20Parliament.png",
    coverAlt: "The Mango Tree Parliament — A Story About Democracy cover",
    palette: { bg: "#F1EFDD", accent: "#3F7A2E", ink: "#1E2E12" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Little Readers",
    series: "Little Readers — Village Tales",
    genres: ["Children", "Picture Book", "Civic Values"],
    genreBlend: ["Children's Fiction", "Civic Storytelling"],
    format: "Illustrated Paperback",
    pages: 72,
    language: "English",
    isbn: "978-81-970005-3-1",
    price: 329,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    ageRange: "6–11 years",
    editorialNote: "A children's tale about the world's largest democracy — told at child-height, under a mango tree, where every disagreement ends in a kinder friendship.",
    synopsis: `Every afternoon, under the biggest mango tree in the village, seven children gather. They call it a Parliament. They vote on what to play, what to share, who spoke too loudly, and who did not get a turn. Sometimes they disagree. Sometimes they change each other's minds. Nobody leaves the tree angry.

The Mango Tree Parliament is a warm, illustrated story about how democracy actually works — one polite disagreement, one shared mango, one changed mind at a time. For readers aged 6–11.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "in-production", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "The Biggest Mango Tree",
      "The First Parliament",
      "Vote One — What to Play",
      "Vote Two — Who Speaks First",
      "The Day They Almost Broke Up",
      "The Mango Everyone Shared",
      "Everyone Goes Home Happier",
    ],
    reviews: [
      { author: "The Better India — Kids", stars: 5, quote: "Every Indian classroom should own this book." },
      { author: "Scroll — Young", stars: 5, quote: "A civic imagination built at child-height." },
    ],
  },
  {
    slug: "the-family-business-code",
    title: "The Family Business Code",
    subtitle: "The Legacy Stories Series",
    tagline: "Families who contributed to nation building.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/2mstoq2j_TFBC.png",
    coverAlt: "The Family Business Code — The Legacy Stories Series cover",
    palette: { bg: "#F2E4C8", accent: "#8A4B1E", ink: "#3A1F0A" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Business",
    series: "The Legacy Stories Series",
    genres: ["Business", "Family Business", "Legacy"],
    genreBlend: ["Business Biography", "Legacy Studies"],
    format: "Hardcover",
    pages: 384,
    language: "English",
    isbn: "978-81-970006-0-9",
    price: 999,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first Indian volume that treats family businesses as nation-builders, not headlines — a portrait of ten families whose second, third, and fourth generations quietly built modern India.",
    synopsis: `Every large modern Indian enterprise you can name — and many you cannot — began at a family dining table. The Family Business Code sits down with ten of them.

Across four years of interviews, archival access, and shop-floor visits from Rajkot to Guwahati, this volume reconstructs the succession logic, capital discipline, and cultural glue that have allowed India's family enterprises to survive Partition, licence-raj, liberalisation, and now digital disruption. It is a book about how a family becomes an institution — and, sometimes, a country.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Dining Table Boardroom",
      "Book I — The Founders (1930–1960)",
      "Book II — The Second Generation",
      "Book III — Liberalisation",
      "Book IV — The Third and Fourth Generation",
      "Book V — The Family, Institutionalised",
      "Coda — What Legacy Actually Is",
    ],
    reviews: [
      { author: "Forbes India", stars: 5, quote: "The definitive volume on Indian family enterprise." },
      { author: "Mint — Long Story", stars: 5, quote: "Reported the way business history should be reported." },
    ],
  },
  {
    slug: "business-in-bharat",
    title: "Business in Bharat",
    subtitle: "Opportunity Begins Beyond Metros",
    tagline: "The next India is being built outside the top eight cities.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/gmddr1sn_Business%20in%20Bharat.png",
    coverAlt: "Business in Bharat — Opportunity Begins Beyond Metros cover",
    palette: { bg: "#F3F6FA", accent: "#F2891F", ink: "#0F2C58" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Business",
    series: "The Bharat Enterprise Series",
    genres: ["Business", "Enterprise", "Tier 2 & 3"],
    genreBlend: ["Business Reportage", "Regional Enterprise"],
    format: "Hardcover",
    pages: 320,
    language: "English",
    isbn: "978-81-970006-1-6",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive field guide to the ₹40-lakh-crore opportunity being built quietly outside India's metros — with case-studies, playbooks, and district-level data.",
    synopsis: `Ludhiana. Coimbatore. Rajkot. Bhubaneshwar. Kanpur. Kochi. Vijayawada. The next India is being written outside its top eight cities — and most metro-based investors, policy-makers, and management writers have not yet noticed.

Business in Bharat is the first serious field guide to this shift. Combining district-level GST data, four hundred field interviews, and case-studies of thirty tier-2 and tier-3 companies scaling nationally, this book is a practical volume for entrepreneurs, corporate strategy teams, investors, and civil servants operating in the Bharat opportunity.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Country Outside the Top Eight",
      "Book I — Ludhiana to Kochi",
      "Book II — Thirty Case-Studies",
      "Book III — The Bharat Playbook",
      "Book IV — Policy, Capital, and Corridors",
      "Coda — Where Opportunity Actually Lives",
    ],
    reviews: [
      { author: "The Economic Times", stars: 5, quote: "The Bharat business book Indian corporate strategy has been missing." },
      { author: "Livemint", stars: 5, quote: "Field-first, data-strong, opinion-restrained." },
    ],
  },
  {
    slug: "negotiation-master",
    title: "Negotiation Master",
    subtitle: "The Deal Story — Influence with Integrity",
    tagline: "The art of the deal, done the honest way.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/fim4hap0_Negotitation%20Master.png",
    coverAlt: "Negotiation Master — Influence with Integrity cover",
    palette: { bg: "#F3EEE0", accent: "#B08B3A", ink: "#1A1613" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Business",
    series: "The Deal Story",
    genres: ["Business", "Negotiation", "Leadership"],
    genreBlend: ["Business Skills", "Behavioural Economics"],
    format: "Hardcover",
    pages: 272,
    language: "English",
    isbn: "978-81-970006-2-3",
    price: 749,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A practical, Indian-context negotiation manual — reported through fifty deal-rooms and translated into a framework you can use before Monday's meeting.",
    synopsis: `Negotiation, done well, does not feel like negotiation. It feels like two people leaving a room with more than they walked in with — and, quietly, trusting each other a little more.

Negotiation Master is a practical volume for Indian founders, sales leaders, procurement heads, and policy-negotiators. Built on fifty deal-room case-studies across boardrooms, ministries, family firms, and the Gulf's largest trade tables, it distills a framework — Prepare, Position, Propose, Preserve — that you can put to work in your next meeting.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "not-licensed", Translation: "in-production", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Influence With Integrity",
      "Part I — Prepare",
      "Part II — Position",
      "Part III — Propose",
      "Part IV — Preserve",
      "Part V — Fifty Deal Rooms",
      "Coda — The Long Game",
    ],
    reviews: [
      { author: "Harvard Business Review India", stars: 5, quote: "The Indian negotiation manual the country did not know it needed." },
      { author: "Business Standard", stars: 5, quote: "Sharp, practical, and quietly ethical." },
    ],
  },
  {
    slug: "indias-next-billion-dollar-ideas",
    title: "India's Next Billion Dollar Ideas",
    subtitle: "Tomorrow's Giants Begin Today",
    tagline: "Where the next twenty Indian unicorns are already being born.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/hktc6cfs_India%27s%20Next%20Billion%20Dollar%20Ideas.png",
    coverAlt: "India's Next Billion Dollar Ideas — Tomorrow's Giants Begin Today cover",
    palette: { bg: "#F2F5F8", accent: "#F27C1F", ink: "#0D2E4A" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Business",
    series: "The Bharat Enterprise Series",
    genres: ["Business", "Startups", "Venture"],
    genreBlend: ["Business Reportage", "Startup Playbook"],
    format: "Hardcover",
    pages: 336,
    language: "English",
    isbn: "978-81-970006-3-0",
    price: 849,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive field-scan of the twenty sectors most likely to produce India's next generation of billion-dollar companies — with data, playbooks, and founder-by-founder profiles.",
    synopsis: `Every ten years, Indian enterprise crosses a threshold that was invisible ten years earlier. Software services in the 1990s. E-commerce in the 2010s. Something new every decade after.

India's Next Billion Dollar Ideas maps the twenty sectors, technologies, and consumption shifts most likely to define the 2030s. Combining venture-capital deal-flow analysis, ministry policy signals, deep-tech readiness scoring, and interviews with 120+ founders, this book is a practical scan — not a horoscope — of where India's next generation of giants is already being built.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "in-production", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Threshold, Again",
      "Book I — Twenty Sectors",
      "Book II — Deep-Tech Readiness",
      "Book III — The Founder Voice",
      "Book IV — The Capital Landscape",
      "Book V — The 2030s Scenario",
      "Coda — What to Watch, and When",
    ],
    reviews: [
      { author: "The Ken", stars: 5, quote: "The most sourced startup-forecast book Indian publishing has produced." },
      { author: "The Economic Times", stars: 5, quote: "Field-first, opinion-restrained, quietly bold." },
    ],
  },
  {
    slug: "the-volunteer-nation",
    title: "The Volunteer Nation",
    subtitle: "The Seva Story",
    tagline: "Service builds civilizations.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/029isek6_The%20Volunteer%20Nation.png",
    coverAlt: "The Volunteer Nation — The Seva Story cover",
    palette: { bg: "#F6F1E5", accent: "#D26B1F", ink: "#0E2A18" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Society",
    series: "The Seva Story",
    genres: ["Society", "Volunteerism", "Civic Life"],
    genreBlend: ["Civic Reportage", "Contemporary History"],
    format: "Hardcover",
    pages: 336,
    language: "English",
    isbn: "978-81-970007-0-7",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first book to treat volunteer culture as national infrastructure — a portrait of the millions of Indians whose seva quietly holds the republic together.",
    synopsis: `Behind every landslide response, every anti-plastic drive, every free coaching class, every langar, every neighbourhood blood-donation camp, is a volunteer no one has named. This book names them.

The Volunteer Nation is the first serious volume to treat seva as national infrastructure — not sentiment, not garnish, but the load-bearing tissue that holds Indian civic life together. Reported across 22 states and built on hundreds of hours of field interviews with volunteers from RSS shakhas, Rotary, Lions, church groups, dargah trusts, gurdwara sangats, and thousands of unbranded neighbourhood WhatsApp groups, it is a portrait of the country as its most patient people already know it.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "in-production",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Volunteer No One Named",
      "Book I — The Traditions of Seva",
      "Book II — Disaster, Health, Education",
      "Book III — The WhatsApp Neighbourhood",
      "Book IV — Seva as Infrastructure",
      "Book V — What The State Learns From Volunteers",
      "Coda — Service Builds Civilizations",
    ],
    reviews: [
      { author: "The Hindu Books", stars: 5, quote: "The book that gives seva its proper Indian name — infrastructure." },
      { author: "The Better India", stars: 5, quote: "A civic love-letter, reported like a court case." },
    ],
  },
  {
    slug: "mission-panchayat",
    title: "Mission Panchayat",
    subtitle: "Democracy Begins at the Grassroots",
    tagline: "The largest local democracy on Earth, up close.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/ikuig43b_Mission%20Panchayat.png",
    coverAlt: "Mission Panchayat — Democracy Begins at the Grassroots cover",
    palette: { bg: "#F1F0DF", accent: "#8A6A28", ink: "#22321C" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Society",
    series: "The Grassroots Series",
    genres: ["Society", "Governance", "Rural India"],
    genreBlend: ["Governance Reportage", "Rural Studies"],
    format: "Hardcover",
    pages: 312,
    language: "English",
    isbn: "978-81-970007-1-4",
    price: 749,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "A deeply reported inside-view of India's 260,000 gram panchayats — the largest local democracy on Earth, and the one Indian journalism least often visits.",
    synopsis: `The Lok Sabha has 543 seats. India's gram panchayats have three million. This is where democracy actually begins.

Mission Panchayat is the definitive contemporary account of local self-government in India — reconstructed through year-long fieldwork across 40 gram panchayats in eight states, over 300 sarpanch interviews, ward-member biographies, and PRI-level budget analysis. It is a book about the elected office nobody covers, the women sarpanches nobody profiles, and the untouched twelve-thousand-crore experiment in devolution that already exists in the room next door.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "not-licensed",
      Series: "in-production", Translation: "available", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — Where Democracy Actually Begins",
      "Book I — Forty Gram Panchayats",
      "Book II — The Women Sarpanches",
      "Book III — PRI Budgets & Devolution",
      "Book IV — The Ward Member",
      "Book V — The Next Twenty Years of Local Democracy",
      "Coda — The Room Next Door",
    ],
    reviews: [
      { author: "Down To Earth", stars: 5, quote: "The panchayat book Indian journalism has owed the country for a generation." },
      { author: "The Wire — Rural Desk", stars: 5, quote: "Field-first, data-strong, urgent." },
    ],
  },
  {
    slug: "the-neighbourhood-that-adopted-itself",
    title: "The Neighbourhood That Adopted Itself",
    subtitle: "A RWA Story",
    tagline: "When the state didn't show up, the community did.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/a19sehjo_The%20Neighbourhood%20That%20Adopted%20Itself.png",
    coverAlt: "The Neighbourhood That Adopted Itself — A RWA Story cover",
    palette: { bg: "#F1EEE1", accent: "#7A652E", ink: "#2A2A1F" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Society",
    series: "The Urban India Series",
    genres: ["Society", "Urban India", "Community"],
    genreBlend: ["Urban Reportage", "Civic Studies"],
    format: "Trade Paperback",
    pages: 264,
    language: "English",
    isbn: "978-81-970007-2-1",
    price: 599,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The first book-length reckoning with the Resident Welfare Association — the quiet parallel republic that Indian urban India is already governed by.",
    synopsis: `Somewhere between the municipal corporation and the front door lies India's most under-studied civic layer: the RWA. Tens of thousands of them. Volunteer-run, unelected, deeply consequential — deciding water, waste, security, parking, and often much more.

The Neighbourhood That Adopted Itself is a full-length portrait of urban India through the RWA lens. Reported across Delhi, Bengaluru, Kolkata, Mumbai, and Chennai, with 220 RWA-office interviews and colony-by-colony case-studies, it argues that when the Indian state has been slow to arrive, the community has quietly adopted itself — for better, and sometimes for complicated.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "in-production", Film: "not-licensed",
      Series: "in-production", Translation: "in-production", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Parallel Republic Next Door",
      "Book I — The RWA, Explained",
      "Book II — Five Cities, Five Case-Studies",
      "Book III — Water, Waste, Security, Parking",
      "Book IV — The RWA and The State",
      "Book V — What Urban India Governs Itself With",
      "Coda — The Neighbourhood, Adopted",
    ],
    reviews: [
      { author: "The Print — Urban", stars: 5, quote: "The RWA book urban India has been waiting to read about itself." },
      { author: "Livemint — Cities", stars: 5, quote: "Sharp, respectful, and quietly revelatory." },
    ],
  },
  {
    slug: "behind-the-migrant-train",
    title: "Behind the Migrant Train",
    subtitle: "A Story of Hardship, Commitment & Contribution",
    tagline: "What the city forgets about the hands that built it.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/fh94yu9d_Behind%20the%20Migrant%20Train.png",
    coverAlt: "Behind the Migrant Train — A Story of Hardship, Commitment & Contribution cover",
    palette: { bg: "#EEF0F2", accent: "#1F2A38", ink: "#0F1A25" },
    authors: ["cbh-editorial-board"],
    imprint: "Conlang Society",
    series: "The Working Bharat Series",
    genres: ["Society", "Migration", "Labour"],
    genreBlend: ["Labour Reportage", "Contemporary History"],
    format: "Hardcover",
    pages: 320,
    language: "English",
    isbn: "978-81-970007-3-8",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2026,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The definitive book on the ninety million internal migrants who built modern urban India — reported through five migration corridors and one long refusal to look away.",
    synopsis: `The tallest tower in every Indian metro was built by hands whose home the metro has never visited. Ninety million internal migrants. Five great migration corridors. One quiet, uncelebrated labour that holds the country up.

Behind the Migrant Train is the definitive contemporary account of internal migration in India — reported over four years across the Bihar–Delhi, Odisha–Surat, Jharkhand–Mumbai, UP–Punjab, and Northeast–Kerala corridors. Combining household surveys, remittance-flow data, and hundreds of on-record interviews at both origin and destination, it is a book about hardship, commitment, and the contribution the country has, for too long, forgotten to name.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "in-production",
      Comic: "not-licensed", Course: "available", Film: "in-production",
      Series: "in-production", Translation: "available", Merchandise: "not-licensed",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — The Hands That Built The City",
      "Book I — Five Migration Corridors",
      "Book II — Origin: The Villages Left Behind",
      "Book III — Destination: The Cities That Rose",
      "Book IV — Remittance, Return, Reunion",
      "Book V — The Migrant, Named",
      "Coda — What The City Forgets",
    ],
    reviews: [
      { author: "The Caravan", stars: 5, quote: "The migration book Indian non-fiction has been circling for a decade." },
      { author: "Scroll — Labour Desk", stars: 5, quote: "Reported the way this subject has always deserved." },
    ],
  },
  {
    slug: "the-man-who-gave-missiles-to-india",
    title: "The Man Who Gave Missiles to India",
    subtitle: "A Journey of Science, Service and Leadership",
    tagline: "The Extraordinary Life of Dr. A.P.J. Abdul Kalam.",
    cover: "https://customer-assets.emergentagent.com/job_cbh-literary-hub/artifacts/hhs387kr_APJ%20Kalam%20Book.png",
    coverAlt: "The Man Who Gave Missiles to India — Dr. APJ Abdul Kalam cover",
    palette: { bg: "#E8EEF5", accent: "#12305E", ink: "#08152E" },
    authors: ["cbh-editorial-board"],
    imprint: "Bharat Icon Series",
    series: "Bharat Icon Series",
    genres: ["Biography", "Science", "Leadership"],
    genreBlend: ["Scientific Biography", "Leadership"],
    format: "Hardcover",
    pages: 344,
    language: "English",
    isbn: "978-81-970000-9-8",
    price: 799,
    priceCurrency: "INR",
    releaseYear: 2025,
    amazonUrl: "https://www.amazon.in/",
    editorialNote: "The complete life of A.P.J. Abdul Kalam — from Rameswaram to Rashtrapati Bhavan — reconstructed with unprecedented archival access.",
    synopsis: `Boatman's son. Aerospace engineer. Missile Man. President of India. Dr. A.P.J. Abdul Kalam's life sits at the improbable intersection of science, service, and civic imagination. This is the fullest single-volume account yet written — from Rameswaram to Rashtrapati Bhavan, from Prithvi to Pokhran, from lab bench to living room.`,
    ipSurface: {
      Book: "available", Ebook: "available", Audiobook: "available",
      Comic: "in-production", Course: "available", Film: "not-licensed",
      Series: "not-licensed", Translation: "available", Merchandise: "available",
      Podcast: "available", "Live Event": "available", "Study Guide": "available",
    },
    tableOfContents: [
      "Prelude — A Boat, A Boy, A Book",
      "Book I — Rameswaram to Bangalore",
      "Book II — SLV-3",
      "Book III — Pokhran",
      "Book IV — Rashtrapati Bhavan",
      "Book V — The Last Lecture",
      "Coda — Wings of Fire, Still",
    ],
    reviews: [
      { author: "The Indian Express", stars: 5, quote: "The Kalam book we've been waiting for." },
      { author: "Deccan Herald", stars: 5, quote: "Reverent without being reverential." },
    ],
  },
];

export const getBookBySlug = (slug) => books.find((b) => b.slug === slug);

export const getBooksByAuthor = (authorSlug) =>
  books.filter((b) => b.authors.includes(authorSlug));

export const allGenres = Array.from(
  new Set(books.flatMap((b) => b.genres))
).sort();

export const allImprints = Array.from(
  new Set(books.map((b) => b.imprint))
).sort();
